module.exports = __webpack_public_path__ + "static/media/YF53_4.188b0dfa.jpg";